import Loading from "components/common/loading/Loading";
import React from "react";

import { Grid } from "@mui/material";
import GridListItem from "components/common/grid/GridListItem";
import { DATE_FORMAT } from "static/date";
import formatDate from "utils/formatDate";

const LeadInformationPreview = ({ leads, isLoading }) => {
  if (isLoading) return <Loading height="50px" />;

  if (!leads || leads?.length === 0) {
    return (
      <div className="d-flex justify-center">No lead information found.</div>
    );
  }

  return (
    <Grid container columnSpacing={3} className="view-pdf__drawer-grid">
      {leads?.length > 0 &&
        leads?.map(
          (
            { type, manufacturer, doi, model, serial_number, active, advisory },
            index
          ) => (
            <Grid
              item
              container
              columnSpacing={2}
              className="view-pdf__drawer-grid"
              key={index}
              xs={11}
            >
              <GridListItem
                title="LEAD TYPE"
                subTitle={type?.toUpperCase() ?? "—"}
                size="2"
              />

              <GridListItem
                title="MANUFACTURER"
                subTitle={manufacturer ?? "—"}
                size="2"
              />
              <GridListItem
                title="DOI"
                subTitle={doi ? formatDate(doi, DATE_FORMAT.DEFAULT) : "—"}
                size="2"
              />

              <GridListItem
                title="MODEL NUMBER"
                subTitle={model ?? "—"}
                size="2"
              />

              <GridListItem
                title="SERIAL NUMBER"
                subTitle={serial_number ?? "—"}
                size="2"
              />

              <Grid
                item
                container
                columnSpacing={3}
                className="view-pdf__drawer-grid"
                key={index}
                xs={2}
              >
                <GridListItem
                  title="ACTIVE"
                  subTitle={active ? "Yes" : "No"}
                  size="4"
                />

                <GridListItem
                  title="ADVISORY"
                  subTitle={advisory ? "Yes" : "No"}
                  size="4"
                />
              </Grid>
            </Grid>
          )
        )}
    </Grid>
  );
};

export default LeadInformationPreview;
